import { ark } from '@ark-ui/react';
import { styled } from '@terra/ui-styled-system';
import { icon } from '@terra/ui-styled-system';
import type { ComponentProps } from '@terra/ui-styled-system';

export type IconProps = ComponentProps<typeof Icon>;
export const Icon = styled(ark.svg, icon, {
  defaultProps: { asChild: true },
});
